import { Component, ReactNode } from "react"
// import * as Sentry from "@sentry/react";
import { Box, Typography, Button, Paper } from "@mui/material"

class ErrorBoundary extends Component<
  { children: ReactNode },
  { hasError: boolean; errorInfo: string; errorMessage: string }
> {
  constructor(props: any) {
    super(props)
    this.state = { hasError: false, errorInfo: "", errorMessage: "" }
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, errorMessage: error.message }
  }

  componentDidCatch(error: Error, errorInfo: any) {
    console.error("ErrorBoundary caught an error", error, errorInfo)

    // Sentry desactivado temporalmente debido a problemas
    // Enviar errores a Sentry en producción
    // if (import.meta.env.MODE === "production") {
    //     Sentry.captureException(error, {
    //         extra: { componentStack: errorInfo?.componentStack },
    //     });
    // }

    this.setState({
      errorInfo: errorInfo?.componentStack || "",
      errorMessage: error.message || "An unexpected error occurred.",
    })
  }

  handleReload = () => {
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      const isDev = import.meta.env.MODE === "development"

      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="100vh"
          bgcolor="grey.100"
          p={2}
        >
          <Paper
            elevation={3}
            sx={{ p: 4, maxWidth: 600, textAlign: "center" }}
          >
            <Typography
              variant="h4"
              color="error"
              gutterBottom
            >
              Oops! Something went wrong.
            </Typography>
            <Typography
              variant="bodyNormal"
              gutterBottom
            >
              {isDev
                ? "Check the details below to debug the issue."
                : "We're working to resolve the problem. Please try refreshing the page."}
            </Typography>

            {isDev && (
              <>
                <Typography
                  variant="h6"
                  color="textSecondary"
                  gutterBottom
                >
                  Error Details:
                </Typography>
                <Box
                  component="pre"
                  sx={{
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    bgcolor: "grey.200",
                    p: 2,
                    borderRadius: 1,
                    maxHeight: "200px",
                    overflow: "auto",
                  }}
                >
                  {this.state.errorMessage}
                </Box>
                <Typography
                  variant="h6"
                  color="textSecondary"
                  gutterBottom
                  mt={2}
                >
                  Stack Trace:
                </Typography>
                <Box
                  component="pre"
                  sx={{
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    bgcolor: "grey.200",
                    p: 2,
                    borderRadius: 1,
                    maxHeight: "300px",
                    overflow: "auto",
                  }}
                >
                  {this.state.errorInfo}
                </Box>
              </>
            )}

            <Button
              variant="contained"
              color="primary"
              onClick={this.handleReload}
              sx={{ mt: 3 }}
            >
              Refresh Page
            </Button>
          </Paper>
        </Box>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
